import { render } from "./FormFieldRichText.vue?vue&type=template&id=2619b9af"
import script from "./FormFieldRichText.vue?vue&type=script&lang=js"
export * from "./FormFieldRichText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__